var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-layout" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.goodsOrderItemList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "title", label: "商品名称", width: "180" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商品图片", width: "60" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("img", {
                      staticStyle: { height: "36px", width: "36px" },
                      attrs: { src: _vm.goodsOrderItemList.skuDefaultImageUrl }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "brandName", label: "品牌", width: "180" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "quantity", label: "数量" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1aaac419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aaac419","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsContractItemList.vue
// module id = 2892
// module chunks = 0